/// <reference path='../_all.ts' />
declare var pglob : IPhotometerGlobalVar;

module library {
  'use strict';


  /**
   * Services that persists and retrieves TODOs from localStorage.
   */
  export class ToolboxService implements IToolboxService {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$rootScope',
      '$http',
      'anchorNavService',
      '$mdDialog',
      '$filter', 
      '$q', 
    ];

    constructor(
      private $rootScope: ng.IRootScopeService,
      private $http: ng.IHttpService,
      private anchorNavService: navigation.IAnchorNavService,
      private $mdDialog: ng.material.IDialogService,
      private $filter : library.IUniqueFilter,
      public $q: ng.IQService,
      ) {}


    public getProducts(): ng.IHttpPromise<search.Product[]> {
      return this.$http<search.Product[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Product/GetAll"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          onlyListed: true
          }
      });
    }

    
  }
}